import { EventBuilder } from './EventBuilder';
import Core from '../Core/Core';

export interface IEntryPointAllParams {
    entryPoint: string; //
    epSenderId: string; // ...not all entry points have senders
    epSenderLevel: number; // same...and we don't send level even with events with a sender
    epTimestamp: number; // we will have to add this property to all outgoing share, messages
    epSenderCoins: number; // same with this
    epContext: string; // ...facebook CONTEXT of entry point
    epPromoSource: string;
}

// are we using these??...NO for now
export interface IEntryPointBotParams {
    epBotMsgCatergory: string; // what...need an enum prob but don't know what this is
    epBotMsgId: string;
    epBotGiftId: string;
    epMsgId: string; // how is this different than epBotMsgId;
    epMagnifyingGlass: number; // hint boosters given - get from ep data
    epFlashLight: number;
    epFireCracker: number;
    epMagnet: number;
    epCoins: number;
    epLives: number;
}

export class EpParamBuilder extends EventBuilder {
    private gameEntryPoint: string = 'unknown';

    constructor() {
        super();
    }

    public setParamsFromGame(data: any) {
        if (data.entryPoint) {
            this.gameEntryPoint = data.entryPoint;
        }
    }

    // get from entry point data
    public getParams<T>(): IEntryPointAllParams {
        const entryPointData = Core.sdk.messages.getEntryPointData() || {};
        // @ts-ignore
        const epPayload = entryPointData.payload || {};
        // @ts-ignore
        const { entryPoint } = entryPointData;
        const { senderId, senderLevel, timestamp, senderCoins, originGameId } = epPayload;
        const sId = senderId || 'none';
        const sLevel = senderLevel || 0;
        const ts = timestamp || 0;
        const sCoins = senderCoins || 0;
        const xpId = originGameId || 'none';
        return {
            entryPoint: this.gameEntryPoint,
            epSenderId: sId,
            epSenderLevel: sLevel,
            epTimestamp: ts,
            epSenderCoins: sCoins,
            epContext: sgPlatform === 'fbinstant' ? FBInstant.context.getType() : 'SOLO',
            epPromoSource: xpId,
        };
    }

    public setParams(keys: Map<string, unknown>): void {
        keys.forEach((value, key) => {});
    }
}
